import styles from './AlertCard.scss';
import React, { useState } from 'react';
//import CheckBox from "../../Common/CommonComponents/SceCheckBox";
import Toggle from './Toggle';
//import contacts from "../common/data.json";
//import InfoIcon from "./InfoIcon";



function Alerts(props) {
  
  const pb=props.AlertName;
  const mp=props.AlertName;
 
  let imageMailOn;
  let imageMailOff;
  let imageTextOn;
  let imageTextOff;
  let imagePhoneOn;
  let imagePhoneOff;
  let button;
  let checked=null;
  let imageMail_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOff.svg';
  let imagePhone_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
  let imageText_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
  


  const accData=props.accountData;
  const prefData=props.preferenceData;
  const component=props.componentName;
  //   if(component!=="Marketing"){
  //     if(prefData.email_id!=="" && prefData.phoneNo!=="" && prefData.text!=="" ){
  //       //alert(JSON.stringify(prefData));
  //      checked=true;
  //     }
   
  //     else{
  //       checked=false;
  //     }


  if(component==='Marketing'){

    if(props.isMkgEnrolled===true){
      checked=true;
    }
    else{
      checked=false;
    }
  }
  else{
    if(prefData.email_id!=='' && prefData.phoneNo!=='' && prefData.text!=='' ){
    //alert(JSON.stringify(prefData));
      checked=true;
    }
 
    else{
    //alert(JSON.stringify(prefData));
      checked=false;
    }
 

  }


  //   }
  //   alert(JSON.stringify(prefData));
  // if(prefData.email_id!=="" && prefData.phoneNo!=="" && prefData.text!=="" ){
  //   //alert(JSON.stringify(prefData));
  //  checked=true;
  // }
 
  // else{
  //   checked=false;
  // }
  //let toggle={checked};
  //alert(checked);
  
  //alert(mp);

  if(pb==='Paperless Billing' || mp==='SCE Updates'){
    imageMailOff=<img src={imageMail_Off} alt="Mail Image off" />;
    button= <button className={styles.ViewEditButton}>View / Edit</button>;
  }
  else{
    imageMailOff=<img src={imageMail_Off} alt="Mail Image off"  />;
    imagePhoneOn=<img src={imagePhone_On} alt="Phone Image off" />;
    imageTextOn=<img src={imageText_On} alt="Text Image off" />;
    button= <button className={styles.ViewEditButton}>View / Edit</button>;
  }
  
  
  return (
    
    <div>
     
      <div className={styles.AlertCards}>
            
        <div className={styles.MainContainer}>
          <div className={styles.LeftContainer}>
            <div className={styles.AlertCardData}>
              <p className={styles.AlertCardTitle}> {props.AlertName} </p>
              <p className={styles.AlertCardSubtitle}> {props.AlertExp}</p> 
              <p>{props.AlertType}</p>

              {imageMailOff} &nbsp;&nbsp;{imagePhoneOn}&nbsp;&nbsp;{imageTextOn} &nbsp;&nbsp;
              {button}
 
            </div>

          </div>
           
          <div className={styles.DividerLine} /> 

          <div className={styles.RightContainer}>
            <div className={styles.SwitchAlign}>
              <Toggle isToggleOn={checked} />
              {/* <Toggle /> */}
             
            </div>
          </div> 
             
            
        </div>
      </div>
    </div>
 
  );}
export default Alerts;
